module.exports = __webpack_public_path__ + "img/tananarive-due.95fc273c.png";